import { render, staticRenderFns } from "./UdemyReports.vue?vue&type=template&id=a2f33180"
import script from "./UdemyReports.vue?vue&type=script&lang=js"
export * from "./UdemyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports